import { FormattedMessage } from 'react-intl';

import messages from './LinkBankAccount.messages';
import styles from './LinkBankAccount.module.css';
import LinkBankAccountForm from './LinkBankAccountForm';

const LinkBankAccount = ({ showTitle = true }) => {
    return (
        <div className={styles.LinkBankAccount}>
            {showTitle && (
                <div className={styles.title}>
                    <FormattedMessage {...messages.linkBankAccountTitle} />
                </div>
            )}
            <div className={styles.content}>
                <div className={styles.description}>
                    <FormattedMessage
                        {...messages.linkBankAccountDescription}
                    />
                </div>
                <LinkBankAccountForm />
            </div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default LinkBankAccount;
